<template>
  <Dialog
    :visible="showModal"
    :modal="true"
    :closable="false"
    class="payment-pending-modal p-dialog-share"
    :breakpoints="{'1360px': '50vw', '1024px': '60vw', '960px': '90vw', '640px': '91vw'}" :style="{width: '35vw'}"
  >
  <template v-if="!isNetworkError" #header>
        <button
          class="p-dialog-header-icon p-dialog-header-close p-link ms-auto"
          type="button"
          @click.prevent="close(false)">
            <i class="p-dialog-header-close-icon pi pi-times"></i>
        </button>
    </template>
  <div class="body">
    <div class="text-center my-4" v-if="isNetworkError">
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 20 20" fill="none" class="info-svg-icon">
        <path d="M10 1C14.9706 1 19 5.02944 19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1ZM10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5ZM10 8.25C10.4142 8.25 10.75 8.58579 10.75 9V14C10.75 14.4142 10.4142 14.75 10 14.75C9.58579 14.75 9.25 14.4142 9.25 14V9C9.25 8.58579 9.58579 8.25 10 8.25ZM10 5.25C10.4142 5.25 10.75 5.58579 10.75 6V6.5C10.75 6.91421 10.4142 7.25 10 7.25C9.58579 7.25 9.25 6.91421 9.25 6.5V6C9.25 5.58579 9.58579 5.25 10 5.25Z" fill="currentColor"/>
      </svg>
    </div>
    <div class="text-center my-4" v-else>
      <i v-if="status===400" class="pi pi-times-circle m-auto color-danger fs-large"></i>
      <i v-else class="pi pi-info-circle m-auto text-primary fs-large"></i>
    </div>
    <div class="my-2 text-center" :class="status===400? 'color-danger' : 'color-primary'" v-if="!isNetworkError && $store.getters.isAuthenticated && !isHefType">
        {{ state.username }}
      </div>
    <div v-if="!isNetworkError" :class="[isHefType ? 'hef-heading' : (status===400? 'color-danger': 'text-primary'), 'text-center mb-1 fw-bold dir-rtl']">
      {{ data.heading }}
    </div>
      <div class="text-center mb-3 fw-bold" :class="[isNetworkError && 'pb-4 border-bottom']" v-if="!isHefType">
         {{ networkErrorOverride?.message ?? data.message }}
      </div>
      <template v-if="!isNetworkError">
        <div class=" text-center mb-2" :class="isHefType ? 'hef-total-label' : (status===400? 'color-danger' : 'color-primary')" data-cy="total-donation-message">
          إجمالي التبرع
        </div>
        <div class="amount-tag rounded m-auto text-center p-1 mb-4 d-flex justify-content-center flex-row-reverse" :class="[status===400 ? 'danger' : '', { 'hef-amount': isHefType && status !== 400 }]" data-cy="donation-amount">
          <span class="px-1">{{ data.amount }}</span>
          <div :class="['sar-icon mt-1', { 'sar-icon--hef': isHefType && status !== 400 }]" />
        </div>
        <div class="w-75 m-auto">
        <div v-if="isSpecificDonationType && !periodicDonation && !isGiftDonation && status !== 400">
            <div :class="['d-block text-center fs-6', isHefType ? 'hef-share-text' : 'color-complementary']" data-cy="share-with-others-message">
              ساهم في العلاج عن طريق مشاركتك الحالة للآخرين
            </div>
            <div v-if="!periodicDonation" :class="[appendSehattyClass('input-wrapper mt-1 mb-4'), { 'hef-input-wrapper': isHefType }]" data-cy="share-with-others">
              <InputText type="text" v-model="state.sharableLink" :placeholder="state.isGeneratingLink ? '...جاري إنشاء الرابط' : ''" disabled ref="shareInput" />
              <Button :class="['p-input-text__icon-wrapper', { 'hef-copy-btn': isHefType }]" @click="copyLink" :disabled="state.isGeneratingLink">

                <i class="pi pi-copy" />
              </Button>
            </div>
          </div>

          <div class="details-table fs-6 mb-4">
         <div :class='appendSehattyClass("header d-flex justify-content-between align-items-center flex-row-reverse rounded-4 px-2 px-lg-5 py-1 ")'>
            <div data-cy="reference-number-label">رقم المرجع</div>
            <div :class="appendSehattyClass('table-val fw-bold')" data-cy="reference-number">{{ data.reference_number }}</div>
          </div>
            <div class="item border-bottom border-1 d-flex justify-content-between align-items-center flex-row-reverse px-3 py-2">
              <div class="mb-2 text-end" data-cy="date-time-label">التاريخ والوقت</div>
              <div class="text-black fw-bold dir-rtl text-start" data-cy="date-time">{{ data.date }}</div>
            </div>
            <div class="item border-bottom border-1 d-flex justify-content-between align-items-center flex-row-reverse px-3 py-2">
              <div class="mb-2" data-cy="payment-method-label">طريقة الدفع</div>
              <div class="text-black fw-bold" data-cy="payment-method">{{ data.payment_method }}</div>
            </div>
            <div class="item border-bottom border-1 d-flex justify-content-between align-items-center flex-row-reverse px-3 py-2"
                v-if="isSpecificDonationType && !periodicDonation && !isGiftDonation">
              <div class="mb-2" data-cy="case-id-label">
                {{ donationType === state.donationType_.CAMPAIGN ? 'رقم الحملة' : donationType === state.donationType_.WAQF ? 'رقم الوقف' : donationType === state.donationType_.HEF ? 'رقم الوقف' : 'رقم الحالة' }}
              </div>
              <div class="text-black fw-bold" data-cy="case-id">{{ data.donation_info?.object_id ? data.donation_info.object_id : '-'}}</div>
            </div>
            <div v-if="!isGiftDonation && !isHefType" class="item border-bottom border-1 d-flex justify-content-between align-items-center flex-row-reverse px-3 py-2">
              <div class="mb-2" data-cy="donation-specialty-label">نوع التبرع</div>
              <div class="text-black fw-bold" v-if="!periodicDonation" data-cy="donation-specialty">{{ data.donation_info?.specialty ? data.donation_info?.specialty : '-'}}</div>
              <div class="text-black fw-bold" v-else>تبرع دوري</div>
            </div>
            <div v-else-if="isGiftDonation && !isHefType" class="item border-bottom border-1 d-flex justify-content-between align-items-center flex-row-reverse px-3 py-2">
              <div class="mb-2" data-cy="donation-specialty-label">تخصص</div>
              <div class="text-black fw-bold" data-cy="donation-specialty">{{ data.donation_info?.specialty }}</div>
            </div> 
            <div class="item  d-flex justify-content-between align-items-center flex-row-reverse px-3 py-2"
                v-if="isSpecificDonationType && !periodicDonation && !isGiftDonation && status !== 400 && !isHefType">
              <div class="mb-2" data-cy="case-details-label">تفاصيل الحالة</div>
              <div class="fw-bold">
                <a :href="state.sharableLink" target="_blank" class="color-complementary" data-cy="case-details-link">
                  إظهار تفاصيل الحالة
                </a>
              </div>
            </div>
            <div v-if="isGiftDonation" >
            <div class="item border-bottom border-1 d-flex justify-content-between align-items-center flex-row-reverse px-3 py-2">
              <div class="mb-2" data-cy="payment-method-label">اسم المهدى له</div>
              <div class="text-black fw-bold" data-cy="payment-method">{{ data.donation_info?.receiver_name }}</div>
            </div>
            <div class="item border-bottom border-1 d-flex justify-content-between align-items-center flex-row-reverse px-3 py-2">
              <div class="mb-2" data-cy="payment-method-label">جوال المهدى له</div>
              <div class="text-black fw-bold" data-cy="payment-method">{{ data.donation_info?.sender_phone_number }}</div>
            </div>
            <div class="item border-bottom border-1 d-flex justify-content-between align-items-center flex-row-reverse px-3 py-2">
              <div class="mb-2" data-cy="payment-method-label">اسم المرسل</div>
              <div class="text-black fw-bold" data-cy="payment-method">{{ data.donation_info?.sender_name  }}</div>
            </div>
            </div>
          </div>
          </div>
        </template>
          </div>
    <div class="w-75 m-auto">
      <div class="text-center">
        <button
          id="submit-btn"
          class="btn btn-lg submit-btn rounded-5 px-5 text-white"
          :class="[status===400 ? 'btn-danger' : 'btn-primary', { 'hef-submit-btn': isHefType }]"
          type="button"
          @click.prevent="close(true)">
          {{  buttonLabel ?? 'الصفحة الرئيسية' }}
        </button>
      </div>
    </div> 
  </Dialog>
</template>

<script setup>
import { useRouter } from 'vue-router';
import {computed, reactive, onMounted } from "vue";
import { DONATION_TYPE } from "@/services/enum.service";
import { ToastSeverity } from "primevue/api";
import { useToast } from 'primevue/usetoast';
import {getLocalValue} from "@/hooks/useLocalStorage";
import { appendSehattyClass, getDomainWithoutProtocol } from "@/helpers/helpers";
import JwtUtilService from "@/services/jwt.util.service";
import AmbassadorService from "@/services/ambassador.service";
import { useStore } from "vuex";
import { getNetworkErrorMessage } from "@/helpers/networkPaymentError";

const toast = useToast();
const props = defineProps({
  showModal: Boolean,
  data: Object,
  periodicDonation: Boolean,
  donationType: String,
  status: Number,
  buttonLabel: {
    type: String,
    default: null
  },
  buttonLink: {
    type: Boolean,
    default: false
  }
});


const state = reactive({
  sharableLink: "",
  isGeneratingLink: false,
  donationType_: DONATION_TYPE,
  username: getLocalValue("username"),
  is_waqf_wallet: getLocalValue("is_waqf_wallet") || false,
  canShareTrackableLink: JwtUtilService.getClientID()?.includes("doner") && useStore().getters.isAuthenticated,

});
const isNetworkError = computed(() => {
  return !!props.data?.isNetworkError;
});
const networkErrorOverride = computed(() => {
  if (!isNetworkError.value) return null;
  return { message: getNetworkErrorMessage() };
});
const isGiftDonation = computed(() => {
  return props.donationType === DONATION_TYPE.GIFT_CARD || props.donationType === 'Gift';
});
const isHefType = computed(() => {
  return props.donationType === DONATION_TYPE.HEF;
});
const isSpecificDonationType = computed(() => {
      const typesToExclude = [
        state.donationType_.ALL_CASES_DONATION,
        state.donationType_.ZAKAT,
        state.donationType_.ALL_PATIENTS
      ];
      return !typesToExclude.includes(props.donationType);
});

const emit = defineEmits(["close"]);
    
const router = useRouter();

const close = (isRedirectHome) =>{
      localStorage.setItem("is_waqf_wallet", false);
      if (isRedirectHome) {
        redirectHome();
      } else {
        redirectToPreviousPage();
      }
      emit("close");
    }
 const redirectToPreviousPage = () =>{
      let path = "/";

      if (props.buttonLink) {
        path = "/admin-panel/periodic-donation";
      } else if (props.data?.donation_info.object_id) {
        switch (props.donationType) {
          case DONATION_TYPE.CASE:
            path = `/donate-case/${props.data.donation_info.object_id}`;
            break;
          case DONATION_TYPE.CAMPAIGN:
            path = `/donate-campaign/${props.data.donation_info.object_id}`;
            break;
          case DONATION_TYPE.WAQF:
            if (!state.is_waqf_wallet) {
              path = `/donate-waqf/${props.data.donation_info.object_id}`;
            }
            break;
        }
      }
      router.push(path);
    }
 const  redirectHome = () => {
      let path = "/";
      if (props.buttonLink) {
        path = "/admin-panel/periodic-donation";
      }
      router.push(path);
    }
const  copyLink=()=> {
    navigator.clipboard.writeText(state.sharableLink);
    if (state.sharableLink) {
      toast.add({ severity: ToastSeverity.SUCCESS, detail: "تم النسخ بنجاح", life: 3000 });
    }
};
const GenerateSharableLink = async () => {
   if (props.periodicDonation) {
      state.sharableLink = process.env.VUE_APP_FE_URL;
      state.sharableLink += "/admin-panel/periodic-donation";
    } 
    else if (props.data.donation_info?.is_completed && props.donationType === DONATION_TYPE.CASE) {
      state.sharableLink = process.env.VUE_APP_FE_URL;
      state.sharableLink += '/completed-cases';
    }
    else {
      const domain = `https://${getDomainWithoutProtocol()}`;
      if (state.canShareTrackableLink) {
        state.isGeneratingLink = true;
        try {
          let response;
          switch (props.donationType) {
            case DONATION_TYPE.CASE:
              response = await AmbassadorService.postCaseNumber({ case: props.data.donation_info.object_id });
              state.sharableLink = `${domain}/c/${response.data.result.case}/${response.data.result.id}`;
              break;
            case DONATION_TYPE.WAQF:
              response = await AmbassadorService.postWaqfNumber({ waqf: props.data.donation_info.object_id });
              state.sharableLink = `${domain}/w/${response.data.result.waqf}/${response.data.result.id}`;
              break;
            case DONATION_TYPE.CAMPAIGN:
              response = await AmbassadorService.postCampaignNumber({ campaign: props.data.donation_info.object_id });
              state.sharableLink = `${domain}/p/${response.data.result.campaign}/${response.data.result.id}`;
              break;
            case DONATION_TYPE.HEF:
              state.sharableLink = `${domain}/h/${props.data?.donation_info?.object_id}/`;
              break;
          }
        } catch (error) {
          generateNonTrackableLink(domain);
        } finally {
          state.isGeneratingLink = false;
        }
      } else {
        generateNonTrackableLink(domain);
        state.isGeneratingLink = false;
      }
    }
}

const generateNonTrackableLink = (domain) => {
  switch (props.donationType) {
    case DONATION_TYPE.CASE: {
      state.sharableLink = `${domain}/c/${props.data?.donation_info?.object_id}`;
      break;
    }
    case DONATION_TYPE.WAQF: {
      state.sharableLink = `${domain}/w/${props.data?.donation_info?.object_id}`;
      break;
    }
    case DONATION_TYPE.CAMPAIGN: {
      state.sharableLink = `${domain}/p/${props.data?.donation_info?.object_id}`;
      break;
    }
    case DONATION_TYPE.HEF: {
      state.sharableLink = `${domain}/h/${props.data?.donation_info?.object_id}/`;
      break;
    }
  }
}

onMounted(()=> {
    if (!isNetworkError.value) {
      GenerateSharableLink();
    }
})
</script>

<style lang="scss" scoped>
@import "@/styles/variables";
@import "@/styles/components/riyal-logo";
.header {
  background: #ECECEC;
}
.table-val {
  color: #000;
}
.color-danger {
  color: #EA5F6D;
}

.hef-heading {
  color: #000;
  font-size: 1.5rem;
}
.hef-total-label {
  color: #6B7280;
}
.hef-amount {
  background: #E7F7F7 !important;
  color: #007F5C !important;
}
.hef-share-text {
  color: #007F5C;
}
.hef-input-wrapper {
  margin-top: 1rem !important;
}
.hef-copy-btn {
  background: #007F5C !important;
  border-color: #007F5C !important;
  &:hover {
    background: #006B4F !important;
    border-color: #006B4F !important;
  }
}
.hef-submit-btn {
  background: #007F5C !important;
  border-color: #007F5C !important;
  &:hover {
    background: #006B4F !important;
    border-color: #006B4F !important;
  }
}
.sar-icon--hef {
  filter: brightness(0) saturate(100%) invert(33%) sepia(98%) saturate(394%) hue-rotate(118deg) brightness(95%) contrast(101%);
  opacity: 1;
}

.submit-btn {
    transition: all 0.5s;

    &:hover {
      opacity: 0.9;
    }

    &.btn-danger {
      background-color: #EA5F6D;
      border-color: #EA5F6D;
    }
  }

.fs-large {
  font-size: 70px;
}

.info-svg-icon {
  color: $color-primary;
  width: 70px;
  height: 70px;
}

.amount-tag {
    width: 110px;
    background: #E7F7F7;
    color: $color-primary;
    &.danger {
      background: $color-gray-lighter;
      color: $color-font-darker;
    }
  }
  .details-table {
    .header {
      background: $color-gray-lighter;
    }

    .item:not(:last-child) {
      border-bottom: $color-secondary;
    }
  }

.dir-rtl {
    direction: rtl;
}
.input-wrapper {
    width: auto !important;
  }

  .details-table {
    .header {
      background: #ECECEC;
      &.sehatty{
        background: $color-sehatty-stroke;
      }
    }

    .item:not(:last-child) {
      border-bottom: 1px solid $color-secondary;
    }
    .item{
      &.sehatty{
        color: $color-sehatty-gray;
      }
    }
  }
</style>
